import WalkthroughSteps from './WalkthroughSteps';

export default WalkthroughSteps;
